import request from '@service/request';
import config from '@config';
import { getAuthOptions } from '@service/utils.js';

const path = `${config.apiURL}/ranking`;
const privatePath = `${config.apiURL}/groups`;

////////////////////////////////////
// Global Ranking

export const fetchTop = () =>
  request.get(path, {
    params: { $limit: 10 },
  });

export const fetchRangeUser = (token, userId) =>
  request.get(path, {
    params: { userId, $limit: 11 },
    ...getAuthOptions(token),
  });

////////////////////////////////////
// Private Rankings

export const getMyRankings = (token, userId) =>
  request.get(privatePath, {
    params: {
      '$or[0][owner]': userId,
      '$or[1][participants]': userId,
    },
    ...getAuthOptions(token),
  });

export const createRanking = (token, name) =>
  request.post(privatePath, { name }, getAuthOptions(token));

export const getRankingById = (token, id) =>
  request.get(`${privatePath}/${id}`, getAuthOptions(token));

export const getRankingByInviteCode = (token, inviteCode) =>
  request.get(`${privatePath}`, {
    params: { inviteCode },
    ...getAuthOptions(token),
  });

export const saveRanking = (token, id, ranking) =>
  request.patch(`${privatePath}/${id}`, ranking, getAuthOptions(token));

export const removeRanking = (token, id) =>
  request.delete(`${privatePath}/${id}`, getAuthOptions(token));

export const acceptInvite = (token, inviteCode) =>
  request.patch(
    `${privatePath}`,
    {},
    {
      params: { inviteCode },
      ...getAuthOptions(token),
    }
  );
